import { useState, useEffect } from "react";
import {
  MenuOutlined,
  LogoutOutlined,
  SettingOutlined,
} from "@ant-design/icons";
import { Layout, Button, Col } from "antd";
import { Sidebar } from "./Sidebar";
import image from "../../images/posmodified3.png";
import moment from "moment";
import "./layout.css";
import { useLocation, useNavigate } from "react-router-dom";
import UsersSettings from "../SettingsUser/UsersSettings";
import EndSession from "./Modal";
import { useTranslation } from "react-i18next";
const { Header } = Layout;
type props = {
  collapsed: boolean;
  setCollapsed: React.Dispatch<React.SetStateAction<boolean>>;
};
export const Navbar = ({ collapsed, setCollapsed }: props) => {
  const [open, setOpen] = useState(false);
  const [username] = useState(localStorage.getItem("userName"));
  const [firstTime, setFirstTime] = useState<boolean>(false);
  const { pathname, state } = useLocation();
  const path = pathname.replace(/\//g, "");
  const [, i18n] = useTranslation("common");
  const dir = i18n.dir();
  useEffect(() => {
    setFirstTime(!state?.isEdit && pathname.split("/").includes("till"));
  }, [pathname]);
  useEffect(() => {
    setCollapsed(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [path]);

  const [settings, setSettings] = useState(false);
  let time = new Date().toLocaleTimeString();

  let [currentTime, changeTime] = useState(time);

  function checkTime() {
    time = new Date().toLocaleTimeString();

    changeTime(time);
  }

  setInterval(checkTime, 1000);

  const navigate = useNavigate();

  const [sessionEnded, setSessionEnded] = useState(
    localStorage.getItem("sessionEnded") === "false"
  );
  const tillId = localStorage.getItem("tillId");
  const location = useLocation();
  useEffect(() => {
    if (location.pathname === `/initial/${tillId}`) {
      setSessionEnded(true);
    }
  }, [location]);

  const handleClick = () => {
    if (!collapsed) {
      setCollapsed(true);
    }
  };

  const isOwner = localStorage.getItem('role')?.toLowerCase() === 'owner'

  return (
    <>
      <Sidebar open={collapsed} setCollapsed={setCollapsed} />
      <UsersSettings sett={settings} setSettings={setSettings} />
      <Layout>
        <Header
          onClick={handleClick}
          className="headerstyle"
          style={
            dir === "ltr"
              ? {
                background:
                  "linear-gradient(270deg, #0048C5 15%, #1677FF 40% , #FFFFFF 100%)",
              }
              : {
                background:
                  "linear-gradient(270deg, #FFFFFF 0%, #1677FF 75%, #0048C5 100%)",
              }
          }
        >
          <Button
            className="iconstyle"
            icon={
              <MenuOutlined
                className="iconstyle"
                style={{
                  color: sessionEnded || firstTime || !isOwner ? "#AAAAAA" : undefined,
                  fontSize: "25px",
                }}
              />
            }
            size={"small"}
            onClick={() => {
              setCollapsed(false);
            }}
            disabled={sessionEnded || firstTime || !isOwner}
          />
          <img
            src={image}
            alt=""
            className={`imagestyle ${sessionEnded ? "disabled" : ""}`}
            onClick={() => !sessionEnded && navigate("/main")}
            style={{
              pointerEvents: sessionEnded || firstTime ? "none" : "auto",
              cursor: sessionEnded || firstTime ? "not-allowed" : "pointer",
            }}
          />

          <Col className="session" style={{ fontSize: "20px" }}>
            {moment().format("DD/MM/YYYY")}
          </Col>
          <Col style={{ color: " #FFFFFF", fontSize: "20px" }}>
            {currentTime}
          </Col>
          <Col style={{ color: " #FFFFFF", fontSize: "20px" }}> {username}</Col>

          <Button
            className="Button"
            type="text"
            icon={<SettingOutlined style={{ fontSize: "25px" }} />}
            size={"small"}
            style={{
              color: sessionEnded || firstTime ? "#AAAAAA" : "#FFFFFF",
              width: "25px",
            }}
            onClick={() => setSettings(true)}
            disabled={sessionEnded || firstTime}
          />
          <Button
            disabled={sessionEnded || firstTime}
            className="Button"
            type="text"
            icon={
              <LogoutOutlined
                style={{
                  fontSize: "25px",
                  color: sessionEnded || firstTime ? "#AAAAAA" : "#FFFFFF",
                }}
              />
            }
            size={"small"}
            onClick={() => {
              setOpen(true);
            }}
          />
          <EndSession
            open={open}
            setOpen={setOpen}
            setSessionEnded={setSessionEnded}
            sessionEnded={sessionEnded}
            firstTime={firstTime}
          />
        </Header>
      </Layout>
    </>
  );
};

